import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'isIconFromAssets',
  standalone: false,
})
export class IsIconFromAssetsPipe implements PipeTransform {
  transform(icon: string | null | undefined): boolean {
    // check if the icon is defined and starts with '/assets/', first slash is optional (regex)
    return !!icon && /^\/?assets\//.test(icon);
  }
}
